// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateBreederBindingManager, UpdateBreederBindingManagerSchema } from 'api/gen/UpdateBreederBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateBreederBindingManagerBaseObject, ValidateBreederBindingManagerBaseObjectSchema } from 'api/gen/ValidateBreederBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateBreederBindingManager'),
  binding: t.union([UpdateBreederBindingManagerSchema, t.null]),
});

export const ValidateUpdateBreederBindingManagerSchema = excess(t.intersection([ValidateBreederBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateBreederBindingManager extends t.TypeOf<typeof ValidateUpdateBreederBindingManagerSchema> {}
